import { Stack, Typography } from '@mui/material'
import { GetOtherSearchesForCandidateQuery } from '__generated__/graphql'
import ProcessStatusTimeline, {
    ProcessStatusTimelineItem,
} from 'shared/components/ProcessStatusTimeline'

export interface OtherSearchesContentProps {
    candidateProcessStatusHistory: GetOtherSearchesForCandidateQuery['getCandidateInOtherSearchesForClient'][number]['candidateProcessStatusHistory']
    rosterName?: string
}

const OtherSearchesContent: React.FC<OtherSearchesContentProps> = ({
    candidateProcessStatusHistory,
    rosterName,
}) => {
    return (
        <Stack direction="column" spacing={2} padding={2}>
            <Typography
                variant="body1"
                fontWeight={500}
            >{`${rosterName ?? ''}`}</Typography>
            <ProcessStatusTimeline
                history={
                    candidateProcessStatusHistory?.map((item) => {
                        const data: ProcessStatusTimelineItem = {
                            processStatus: item.processStatus?.statusLabel,
                            createdByUserPreferredName: `${item.createdByUser?.preferredName ?? 'Unknown'}`,
                            createdAt: item.createdAt,
                        }
                        return data
                    }) ?? []
                }
            />
        </Stack>
    )
}

export default OtherSearchesContent
